var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#BFDFF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5568 18V9.27273H13.6136V18H11.5568ZM12.5909 8.03409C12.2652 8.03409 11.9848 7.92614 11.75 7.71023C11.5152 7.49053 11.3977 7.22727 11.3977 6.92045C11.3977 6.60985 11.5152 6.34659 11.75 6.13068C11.9848 5.91098 12.2652 5.80114 12.5909 5.80114C12.9205 5.80114 13.2008 5.91098 13.4318 6.13068C13.6667 6.34659 13.7841 6.60985 13.7841 6.92045C13.7841 7.22727 13.6667 7.49053 13.4318 7.71023C13.2008 7.92614 12.9205 8.03409 12.5909 8.03409Z",
    fill: "#2D97E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconOffer);
export default __webpack_public_path__ + "static/media/info-icon-offer.25a6774ed799872ae8efc1743c39a60a.svg";
export { ForwardRef as ReactComponent };